import React, { useState } from "react"
// EXTERNAL COMPONENTS
import { makeStyles, Input } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import SaveIcon from "@material-ui/icons/Save"

// INTERNAL COMPONENTS
import { architechtureStyles } from "../../utils/architechtureStyles"

const useStyles = makeStyles((theme) => architechtureStyles(theme))

const EditAreaInput = ({ areaName, setValueEditArea }) => {
  const classes = useStyles()
  const [value, setValue] = useState(areaName)

  const handleChangeCreateArea = ({ target }) => {
    const { value } = target
    setValueEditArea(value.toUpperCase())
    setValue(value.toUpperCase())
  }

  return (
    <div>
      <>
        <div className={classes.areaAndEditContainer2}>
          <div className={classes.areaContainer2}>
            <Input
              className={classes.addAreaInput}
              placeholder={!value ? "NOMBRE DE ÁREA" : value}
              inputProps={{ "aria-label": "description" }}
              disableUnderline={true}
              onChange={(e) => handleChangeCreateArea(e)}
              autoFocus
              value={value}
            />
          </div>
        </div>
      </>
    </div>
  )
}

export default EditAreaInput
